module.exports = __webpack_public_path__ + "static/media/Slide19.44f84ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide19.png
// module id = 1641
// module chunks = 0